export default __webpack_public_path__ + "locales/si/ChangePortalOwner.json?hash=0b0b8eae5b8095cfe0d5d96d00efb592";